import '@/ui/main.scss'
import { createVuetify, type ThemeDefinition } from 'vuetify'
import { aliases, fa } from 'vuetify/iconsets/fa'

const sosvTheme: ThemeDefinition = {
  dark: false,  
  colors: {
    // surface: '#F4F7FF',
    background: '#dfe4ee',
    primary: '#295fd2',
    secondary: '#afbdd8',
    success: '#4ba59d',
    info: '#295fd2',
  },
  variables: {
    'border-color': '#3a568e',
    'theme-on-background': '#2A2464',
    'theme-surface-light': '#FFF',
    'theme-on-surface': '#2A2464'
  }
}

export default defineNuxtPlugin((app) => {
  const vuetify = createVuetify({
    icons: {
      defaultSet: 'fa',
      aliases,
      sets: {
        fa
      }
    },
    theme: {
      defaultTheme: 'sosvTheme',
      themes: {
        sosvTheme
      }
    }
  })
  app.vueApp.use(vuetify)
})
